import { Action, ThunkAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import adminReducer from './features/admin/reducer';
import { loaderReducer } from './features/loader/reducer';
import dashboardReducer from './features/dashboard/reducer';
import { filtersReducer } from './features/filters/reducer';
import { themeBlackReducer } from './features/theme/reducer';

const rootReducer = combineReducers({
    admin: adminReducer,
    filters: filtersReducer,
    loader: loaderReducer,
    dashboard: dashboardReducer,
    themeBlack: themeBlackReducer,
});

const persistedReducer = persistReducer(
    {
        key: 'root',
        storage,
        whitelist: ['data', 'themeBlack']
    },
    rootReducer
);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const persistor = persistStore(store);
